import React, { useEffect, useState } from "react";
import { get, put, post } from "../../../api";
import Admin from "../Dashboard/Admin";
import Footer from "../Dashboard/Footer";
import { formatDateString } from "../../../utils/date";
import { useForm } from "react-hook-form";
import Error from "../../Common/Alert/Error";
import Success from "../../Common/Alert/Success";

function ManageSubscriptions() {
  // const [user, setUser] = useState();
  const [reviewList, setReviewList] = useState([]);
  const [subList, setSubList] = useState([]);
  const [careProvidersList, setCareProvidersList] = useState([]);
  const [activeTab, setActiveTab] = useState('review');
  const [isLoading, setLoading] = useState(false);
  const [subscriptionApiMsg, setSubscriptionApiMsg] = useState("");
  const [subscriptionApiMsgDate, setSubscriptionApiMsgForDate] = useState("");
  const { register, getValues } = useForm();
  useEffect(() => {
    getAllSubscriptionList();
    getAllCareProvidersSubscriptions();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const getAllSubscriptionList = async () => {
    try {
      const url = `/user/company/subscription/list`;
      const response = await get(url);
      setSubList(response);
      getSubscriptionList();
    } catch (e) {
      console.log(e);
    }
  };
  const getSubscriptionList = async () => {
    try {
      const url = `/user/company/subscription?type=Review`;
      const response = await get(url);
      setReviewList(response);
    } catch (e) {
      console.log(e);
    }
  };

  const getAllCareProvidersSubscriptions = async () => {
    try {
      const url = `/user/company/careproviders/subscriptions`;
      const response = await get(url);
      console.log('Care Providers API Response:', response);
      setCareProvidersList(response);
    } catch (e) {
      console.log('Error fetching care providers:', e);
    }
  };
  const getFeesValue = (subValue) => {
    console.log("subValue", subValue);
    console.log("subList", subList);
    const list = subList?.filter((itm) => itm?.subscriptionId === subValue);
    console.log("list", list);
    if (list?.length > 0) {
      return list[0].fee;
    } else {
      return 0;
    }
  };
  const updateSubscriptionRequest = async (subscription, status) => {
    const startDate = getValues(`subscription-${subscription?.subscriptionId}`);
    setSubscriptionApiMsgForDate("");

    const feeValue = getFeesValue(subscription?.toSubscription);

    const payload = {
      companyId: subscription?.companyId,
      subscriptionType: subscription?.subscription?.subscriptionId,
      companySubscriptionId: subscription?.subscriptionId,
      companySubscriptionStatus: status,
      startDate: startDate,
      fee: feeValue,
    };
    console.log("status", status);
    console.log("subscription", subscription);
    if (startDate) {
      try {
        setLoading(true);
        setSubscriptionApiMsg("");
        const url = `user/company/subscription`;
        const response = await put(url, payload);
        if (
          response?.status === 201 ||
          response?.status === 200 ||
          response?.status === 202 ||
          response?.status === 204
        ) {
          setSubscriptionApiMsg("success");
          getSubscriptionList();
          getAllCareProvidersSubscriptions(); // Refresh the care providers list too

          // Notify admins when a subscription is activated
          if (status === "Active") {
            try {
              const notifyBody = {
                companyId: subscription?.companyId,
                companyName: subscription?.companyName,
                plan: subscription?.toSubscription,
                subscriptionDateTime: startDate,
              };
              await post(`/email/notify-subscription`, notifyBody);
            } catch (notifyErr) {
              // Non-blocking: log and continue
              console.log("Subscription notify error", notifyErr);
            }
          }

        } else {
          setSubscriptionApiMsg("error");
        }
        setLoading(false);
      } catch (e) {
        setLoading(false);
      }
    } else {
      setSubscriptionApiMsgForDate("error");
      return;
    }
  };
  return (
    <div className="page-wrapper dashboard ">
      <Admin />
      {isLoading && <div className="preloader"></div>}
      <section className="user-dashboard">
        <div className="dashboard-outer">
          <div className="upper-title-box">
            <h3>Manage Subscriptions</h3>
          </div>

          <div className="row">
            <div className="col-lg-12">
              {/* <!-- Ls widget --> */}
              <div className="ls-widget">
                <div className="tabs-box">
                  <div className="widget-title"></div>

                  <div className="widget-content">
                    <div className="default-tabs style-two tabs-box">
                      <div className="tab-btns tab-buttons clearfix">
                        <div 
                          className={`tab-btn ${activeTab === 'review' ? 'active-btn' : ''}`}
                          onClick={() => setActiveTab('review')}
                          style={{ cursor: 'pointer', padding: '10px 20px', marginRight: '10px', backgroundColor: activeTab === 'review' ? '#1967d2' : '#f8f9fa', color: activeTab === 'review' ? 'white' : '#333', border: '1px solid #ddd', borderRadius: '4px' }}
                        >
                          Review Subscriptions
                        </div>
                        <div 
                          className={`tab-btn ${activeTab === 'all' ? 'active-btn' : ''}`}
                          onClick={() => setActiveTab('all')}
                          style={{ cursor: 'pointer', padding: '10px 20px', backgroundColor: activeTab === 'all' ? '#1967d2' : '#f8f9fa', color: activeTab === 'all' ? 'white' : '#333', border: '1px solid #ddd', borderRadius: '4px' }}
                        >
                          All Care Providers
                        </div>
                      </div>

                      {activeTab === 'review' && (
                        <div className="message-box info">
                          <p>
                            Select start date for subscription before approving
                            and marking as paid.
                          </p>
                        </div>
                      )}

                      <div className="tabs-content">
                        {/* Review Subscriptions Tab */}
                        {activeTab === 'review' && (
                          <div
                            className="tab active-tab animated fadeIn"
                            id="tab1"
                            style={{ display: "block" }}
                          >
                            <div className="row">
                              <div className="col-lg-12">
                                {subscriptionApiMsg === "success" && (
                                  <Success msg={`Success: Subscription saved.`} />
                                )}
                                {subscriptionApiMsgDate === "error" && (
                                  <Error
                                    msg={`Error: Please select start date to proceed.`}
                                    setParentState={setSubscriptionApiMsgForDate}
                                  />
                                )}
                                {setSubscriptionApiMsgForDate === "error" && (
                                  <Error
                                    msg={`Error: Please Select Date to proceed.`}
                                  />
                                )}
                                {subscriptionApiMsg === "error" && (
                                  <Error
                                    msg={`Error: Something went wrong. Please try again.`}
                                  />
                                )}
                                <div className="notification-widget ls-widget">
                                  <div className="">
                                    <div className="widget-content">
                                      <div className="table-outer">
                                        <table className="default-table">
                                          <thead>
                                            <tr>
                                              <th>Care provider</th>
                                              <th>From</th>
                                              <th>To</th>
                                              <th>Fee</th>
                                              <th>Request Date</th>
                                              <th>Start Date</th>
                                              <th>Action</th>
                                            </tr>
                                          </thead>

                                          <tbody>
                                            {reviewList?.length === 0 && (
                                              <tr>
                                                <td colSpan="7">No Result Found</td>
                                              </tr>
                                            )}
                                            {reviewList?.map((itm) => (
                                              <tr key={itm?.subscriptionId}>
                                                <td>{itm?.companyName}</td>
                                                <td>{itm?.fromSubscription}</td>
                                                <td>{itm?.toSubscription}</td>
                                                <td>
                                                  £
                                                  {getFeesValue(
                                                    itm?.toSubscription
                                                  )}
                                                </td>
                                                <td>
                                                  {formatDateString(
                                                    itm?.subscriptionDate
                                                  )}
                                                </td>
                                                <td>
                                                  <input
                                                    type="date"
                                                    {...register(
                                                      `subscription-${itm?.subscriptionId}`
                                                    )}
                                                  />
                                                </td>
                                                <td
                                                  style={{
                                                    paddingLeft: "0",
                                                  }}
                                                >
                                                  <div className="option-box">
                                                    <ul className="option-list">
                                                      <li>
                                                        <button
                                                          className="text-danger"
                                                          data-text="Cancel Request"
                                                          onClick={() => {
                                                            updateSubscriptionRequest(
                                                              itm,
                                                              "Cancelled"
                                                            );
                                                          }}
                                                        >
                                                          <span className="la la-times-circle"></span>
                                                        </button>
                                                      </li>
                                                      <li>
                                                        <button
                                                          data-text="Mark as paid"
                                                          onClick={() => {
                                                            updateSubscriptionRequest(
                                                              itm,
                                                              "Active"
                                                            );
                                                          }}
                                                        >
                                                          <span className="la la-check-circle"></span>
                                                        </button>
                                                      </li>
                                                    </ul>
                                                  </div>
                                                </td>
                                              </tr>
                                            ))}
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}

                        {/* All Care Providers Tab */}
                        {activeTab === 'all' && (
                          <div
                            className="tab active-tab animated fadeIn"
                            id="tab2"
                            style={{ display: "block" }}
                          >
                            <div className="row">
                              <div className="col-lg-12">
                                
                                <div className="notification-widget ls-widget">
                                  <div className="">
                                    <div className="widget-content">
                                      <div className="table-outer">
                                        <table className="default-table">
                                          <thead>
                                            <tr>
                                              <th>Care Provider</th>
                                              <th>Subscription Type</th>
                                              <th>Status</th>
                                              <th>Job Posts</th>
                                              <th>Carers</th>
                                              <th>Meetings</th>
                                              <th>Start Date</th>
                                              <th>End Date</th>
                                            </tr>
                                          </thead>

                                          <tbody>
                                            {(!careProvidersList || careProvidersList?.length === 0) && (
                                              <tr>
                                                <td colSpan="8" style={{ textAlign: 'center', padding: '20px' }}>
                                                  {!careProvidersList ? 'Loading...' : 'No Result Found'}
                                                </td>
                                              </tr>
                                            )}
                                            {careProvidersList && careProvidersList?.length > 0 && careProvidersList?.map((provider, index) => (
                                              <tr key={provider?.subscriptionId || index}>
                                                <td>{provider?.companyName || 'N/A'}</td>
                                                <td>
                                                  <span style={{
                                                    padding: '4px 8px',
                                                    borderRadius: '4px',
                                                    fontSize: '12px',
                                                    fontWeight: 'bold',
                                                    backgroundColor: 
                                                      provider?.toSubscription === 'Free' ? '#28a745' :
                                                      provider?.toSubscription === 'Premium' ? '#ffc107' :
                                                      provider?.toSubscription === 'Enterprise' ? '#17a2b8' :
                                                      '#6c757d',
                                                    color: 'white'
                                                  }}>
                                                    {provider?.toSubscription || 'N/A'}
                                                  </span>
                                                </td>
                                                <td>
                                                  <span style={{
                                                    padding: '4px 8px',
                                                    borderRadius: '4px',
                                                    fontSize: '12px',
                                                    fontWeight: 'bold',
                                                    backgroundColor: 
                                                      provider?.status === 'Active' ? '#28a745' :
                                                      provider?.status === 'InActive' ? '#dc3545' :
                                                      provider?.status === 'Review' ? '#ffc107' :
                                                      '#6c757d',
                                                    color: 'white'
                                                  }}>
                                                    {provider?.status}
                                                  </span>
                                                </td>
                                                <td>{provider?.currentSubscriptionValue?.jobPost || 0}</td>
                                                <td>{provider?.currentSubscriptionValue?.carer || 0}</td>
                                                <td>{provider?.currentSubscriptionValue?.meetings || 0}</td>
                                                <td>
                                                  {provider?.subscriptionDate ? 
                                                    formatDateString(provider.subscriptionDate) : 'N/A'
                                                  }
                                                </td>
                                                <td>
                                                  {provider?.endDate ? 
                                                    formatDateString(provider.endDate) : 'N/A'
                                                  }
                                                </td>
                                              </tr>
                                            ))}
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}

export default ManageSubscriptions;
